import { useIntl } from "react-intl";
import { Button } from "src/components/atoms/Button";
import { Input } from "src/components/atoms/Input";
import { msg } from "src/i18n/Msg";
import styles from "src/components/forms/PromoCodeForm/styles.module.css";
import React from "react";
import { useFormik } from "src/hooks/useFormik";
import { useApplyPromoCode } from "src/queries/useApplyPromoCode";
import { RESPONSSTAUTS } from "src/types/api";
import { validators } from "src/utils/validators";
import { Loader } from "src/components/atoms/Loader";

type Props = {
  close: () => void;
  onApplied?: (info: { minDeposit: number; bonus: number }) => void;
};

export const PromoCodeForm: React.FC<Props> = ({ close, onApplied }) => {
  const intl = useIntl();
  const { applyPromoCodeMutate, errorMessage, setErrorMessage, isPending } =
    useApplyPromoCode();
  const { handleSubmit, setFieldValue, values, errors } = useFormik({
    initialValues: {
      promoCode: "",
    },
    validationSchema: validators.promoCodeForm,
    onSubmit: (body) => {
      applyPromoCodeMutate(
        {
          code: body.promoCode,
        },
        {
          onSuccess: (data) => {
            if (data?.status === RESPONSSTAUTS.SUCCESS) {
              setErrorMessage({
                code: "",
                globalError: [],
              });
              // Показываем поп-ап «Пополните на сумму от X и получите бонус Y»
              // (X/Y приходят из настроек реф. бонуса в ответе apply-promo).
              const info = (data as any)?.data;
              if (onApplied) {
                onApplied({
                  minDeposit: Number(info?.min_deposit ?? 0),
                  bonus: Number(info?.bonus ?? 0),
                });
              } else {
                close();
              }
            }
          },
        }
      );
    },
  });
  const isGlobalError = errorMessage?.globalError?.length > 0;
  const handleChange = (key: string, value: string) => {
    if (errorMessage.code || isGlobalError) {
      setErrorMessage({
        code: "",
        globalError: [],
      });
    }
    setFieldValue(key, value);
  };

  if (isPending) {
    return <Loader />;
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit} noValidate>
      <Input
        value={values.promoCode}
        onChange={(e) => handleChange("promoCode", e.target.value)}
        error={errors.promoCode || errorMessage.code}
        errorWithoutTranslation={!!errorMessage.code}
        placeholder={msg(intl, {
          id: "components.forms.PromoCodeForm.promocode.placeholder",
        })}
      />
      {isGlobalError &&
        errorMessage.globalError.map((error) => (
          <p className="errorText">{error}</p>
        ))}
      <Button
        disabled={isPending}
        type="submit"
        text={{ id: "components.organisms.PromoCodeForm.submit" }}
      />
    </form>
  );
};
